const env = {
  //用户自定义档案
  HTTP_FETCH_USERDEF_USERDEFLIST: gen('/userdefine/getUserDefs?terminaltype=PC&token={0}'), // 基础服务
  HTTP_FETCH_USERDEF_USERDEFARCHIVEBYDEFINEID: gen('/userdefine/getUserDefineByDefineId?terminaltype=PC&token={0}'), // 基础服务
  HTTP_USERDEF_GETREFFIELDS: gen('/userDef/getAAFields?terminaltype=PC&token={0}'),
  HTTP_USERDEF_UPDATEUSERDEF: gen('/userdefine/updateUserDef?terminaltype=PC&token={0}'), // 基础服务
  HTTP_USERDEF_GETSCOPETREEDATA: gen('/userDef/getScopesByClassId?terminaltype=PC&token={0}'),
  HTTP_USERDEFINE_ENUMS: gen('/userdefine/enums?terminaltype=PC&token={0}'), // 获取枚举项
  HTTP_USERDEFINE_DOMAINS: gen('/userdefine/domains?terminaltype=PC&token={0}'), // 获取开通域名
  HTTP_USERDEFINE_ACHIVEREFS: gen('/userdefine/achiverefs?terminaltype=PC&token={0}'), // 根据domain获取参照
  HTTP_USERDEFINE_REFRETS: gen('/userdefine/refrets?terminaltype=PC&token={0}') // 获取参照返回值
}

export default env

export function combine(baseurl, pathname) {
  const separator = (/\/$/.test(baseurl) === false && /^\//.test(pathname) === false) ? '/' : ''
  return Array.prototype.slice.call(arguments, 0).join(separator)
}

function gen(url) {
  return combine('/uniform', url)
}



// WEBPACK FOOTER //
// ./src/common/helpers/env.jsx